export const MIN_DATE_RANGE = '2020-01-01'

export const CUSTOMER_GROUP_REPORT_COLUMNS = [
  {
    key: 'customer_group_name',
    label: 'Customer Group Name',
    headerStyle: 'min-w-250px',
    isSorted: true,
  },
  {
    key: 'total_order_count',
    label: 'Order',
    headerStyle: 'min-w-100px',
    isSorted: true,
    isColumnTotal: true,
  },
  {
    key: 'total_shipping',
    label: 'Total Shipping',
    headerStyle: 'min-w-175px',
    isSorted: true,
    isColumnTotal: true,
  },
  // {
  //   key: 'contributed_revenue_percentage',
  //   label: 'Contribution to Sales(%)',
  //   headerStyle: 'min-w-250px',
  // },
  {
    key: 'contributed_shipping_percentage',
    label: 'CONTRIBUTED Shipping (%)',
    headerStyle: 'w-250px',
    isSorted: true,
  },
  {
    key: 'chart',
    label: 'Chart',
    headerStyle: 'min-w-70px',
    style: 'justify-content-end',
  },
]

export const CUSTOMER_TYPE_REPORT_COLUMNS = [
  {
    key: 'customer_type',
    label: 'Customer Type',
    headerStyle: 'min-w-250px',
    isSorted: true,
  },
  {
    key: 'total_order_count',
    label: 'Order',
    headerStyle: 'min-w-100px',
    isSorted: true,
    isColumnTotal: true,
  },
  {
    key: 'total_shipping',
    label: 'Total Shipping',
    headerStyle: 'min-w-100px',
    isSorted: true,
    isColumnTotal: true,
  },
  {
    key: 'contributed_shipping_percentage',
    label: 'CONTRIBUTED Shipping (%)',
    headerStyle: 'w-250px',
    isSorted: true,
  },
  {
    key: 'chart',
    label: 'Chart',
    headerStyle: 'min-w-70px',
    style: 'justify-content-end',
  },
]

export const SALES_REP_TYPE_REPORT_COLUMNS = [
  {
    key: 'sales_rep_type',
    label: 'Sales Rep Type',
    headerStyle: 'min-w-250px',
    isSorted: true,
  },
  {
    key: 'total_order_count',
    label: 'Order',
    headerStyle: 'min-w-100px',
    isSorted: true,
    isColumnTotal: true,
  },
  {
    key: 'total_shipping',
    label: 'Total Shipping',
    headerStyle: 'min-w-175px',
    isSorted: true,
    isColumnTotal: true,
  },
  {
    key: 'contributed_shipping_percentage',
    label: 'CONTRIBUTED Shipping (%)',
    headerStyle: 'w-250px',
    isSorted: true,
  },
  {
    key: 'chart',
    label: 'Chart',
    headerStyle: 'min-w-70px',
    style: 'justify-content-end',
  },
]

export const SALES_REP_REPORT_COLUMNS = [
  {
    key: 'rep_name',
    label: 'Sales Rep',
    isSorted: true,
    headerStyle: 'min-w-200px',
  },
  {
    key: 'rep_email',
    label: 'Sales Rep Email',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {key: 'rep_type', label: 'Sales Rep Type', isSorted: true, headerStyle: 'min-w-200px'},
  {
    key: 'total_order_count',
    label: 'Order',
    isSorted: true,
    headerStyle: 'min-w-100px',
    isColumnTotal: true,
  },
  {
    key: 'total_shipping',
    label: 'Total Shipping',
    isSorted: true,
    headerStyle: 'min-w-175px',
    isColumnTotal: true,
  },
  {
    key: 'contributed_shipping_percentage',
    label: 'CONTRIBUTED Shipping (%)',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'chart',
    label: 'Chart',
    headerStyle: 'min-w-70px',
    style: 'justify-content-end',
  },
]

export const dataToCustomerGroupReportCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'CUSTOMER GROUP NAME': item?.customer_group_name || '',
      'ORDER': item?.total_order_count || 0,
      'TOTAL SHIPPING': '$' + item?.total_shipping || '$0',
      'CONTRIBUTED SHIPPING (%)':
        item?.contributed_shipping_percentage != null
          ? `${item.contributed_shipping_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToCustomerTypeReportCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'CUSTOMER TYPE': item?.customer_type || '',
      'ORDER': item?.total_order_count || 0,
      'TOTAL SHIPPING': '$' + item?.total_shipping || '$0',
      'CONTRIBUTED SHIPPING (%)':
        item?.contributed_shipping_percentage != null
          ? `${item.contributed_shipping_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToSalesRepShippingCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'SALES REP': item?.rep_name || '',
      'SALES REP EMAIL': item?.rep_email || '',
      'SALES REP TYPE': item?.rep_type || '',
      'ORDER': item?.total_order_count || 0,
      'TOTAL SHIPPING': '$' + item?.total_shipping || '$0',
      'CONTRIBUTED SHIPPING (%)':
        item?.contributed_shipping_percentage != null
          ? `${item.contributed_shipping_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToSalesRepTypeReportCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'SALES REP TYPE': item?.sales_rep_type || '',
      'ORDER': item?.total_order_count || 0,
      'TOTAL SHIPPING': '$' + item?.total_shipping || '$0',
      'CONTRIBUTED SHIPPING (%)':
        item?.contributed_shipping_percentage != null
          ? `${item.contributed_shipping_percentage}%`
          : '0%',
    })
  })

  return results
}

export const ENTITY_PERFORMANCE_CHART_VIEW_OPTIONS = (startDate: string, endDate: string) => {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)
  const timeDiff = endDateObj.getTime() - startDateObj.getTime()
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

  if (daysDiff <= 30) {
    // Up to 1 month
    return [
      {label: 'Day', value: 'day'},
      {label: 'Week', value: 'week'},
    ]
  } else if (daysDiff <= 180) {
    // Between 1 and 6 months
    return [
      {label: 'Week', value: 'week'},
      {label: 'Month', value: 'month'},
    ]
  } else {
    // More than 6 months
    return [
      {label: 'Month', value: 'month'},
      {label: 'Year', value: 'year'},
    ]
  }
}
